<div
  style="display: grid; grid-template-columns: var(--mgmt-col) auto"
  class="fill-height overflow-hidden"
  >
  <e-list header="Apps" separateRight search [(searchText)]="searchText">
    <div class="w-100 d-flex align-items-center" slot="header">
      <egi-app-select
        style="flex: 1"
        #appSelect
        [(egiApp)]="appToLink"
        [blacklist]="linkedApps"
      ></egi-app-select>
      <button
        eBtn
        class="ml-2 mgmt-add-btn"
        [disabled]="!appToLink || appToLink.isDefault"
        (click)="linkNewAppToUserGroup()"
        color="primary"
        icon="plus"
        squared
      ></button>
    </div>

    @for (app of filteredLinkedApps; track app) {
      <e-collapsible-list-item
        [title]="app.name"
        [active]="activeApp.is(app)"
        [class.highlight-filter]="app.is(filteredApp)"
        [opened]="activeApp.is(app)"
        (click)="selectActiveApp(app)"
        class="animate__animated animate__fadeIn"
        clickable
        actionsOnHover
        >
        <ng-container slot="actions">
          <button
            eBtn
            textColor="danger"
            size="sm"
            class="clickable"
            icon="trash"
            (click)="onRemove(app, $event)"
          ></button>
        </ng-container>
      </e-collapsible-list-item>
    }
  </e-list>

  @if (activeApp.isNotDefault) {
    <user-group-linked-app-authorizations-editor
      class="fill-height"
      [userGroup]="activeUserGroup"
      [app]="activeApp"
    ></user-group-linked-app-authorizations-editor>
  }
</div>
